import { ROUTES } from "../constants";
import { SecondaryMenuItem } from "../types";

export const SecondaryMenuItems: SecondaryMenuItem[] = [
  {
    name: "Home",
    pathTo: ROUTES.HOME,
    isExternal: false,
  },
  {
    name: "Aree",
    pathTo: ROUTES.AREE,
    isExternal: false,
  },
  {
    name: "Food",
    pathTo: ROUTES.FOOD,
    isExternal: false,
  },
  {
    name: "Escape Room",
    pathTo: ROUTES.ESCAPE_TOWER,
    isExternal: false,
  },
  {
    name: "Tornei",
    pathTo: ROUTES.TORNEI,
    isExternal: false,
  } /*
  {
    name: "Tales Park",
    pathTo: ROUTES.TALES_PARK,
    isExternal: false,
  },*/,
  {
    name: "F.A.Q.",
    pathTo: ROUTES.FAQ,
    isExternal: false,
  },
];
